import { render, staticRenderFns } from "./Beauty.vue?vue&type=template&id=0ef22198"
import script from "./Beauty.vue?vue&type=script&lang=js"
export * from "./Beauty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports